export default "__VITE_ASSET__CQ0iga6b__"